import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { customerApi } from "../lib/api";
import { useCustomerAuth } from "../context/CustomerAuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useCustomerAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await customerApi.post("/customer/session", {}, { headers: { "X-Session-ID": sid } });
        if (data.session_token) localStorage.setItem("gv_customer_token", data.session_token);
        setUser(data.user);
        window.history.replaceState(null, "", "/account");
        navigate("/account", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-gray-300" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
